import React, { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { useAppContext } from '../context/AppContext';
import HeroSection from '../components/surf/HeroSection';
import CoachingSection from '../components/surf/CoachingSection';
import ProductsGrid from '../components/surf/ProductsGrid';
import AboutSection from '../components/surf/AboutSection';
import TestimonialsSection from '../components/surf/TestimonialsSection';
import Footer from '../components/surf/Footer';

// Mock services data
const mockLessons = [
  {
    id: '1',
    title: 'Pro Private Coaching',
    description: '1-on-1 surfing coaching with professional instructors',
    price: 150,
    duration: '1 hour',
    level: 'all',
  },
  {
    id: '2',
    title: '5-Day Surf Camp',
    description: 'Intensive 5-day surf camp for all levels',
    price: 500,
    duration: '5 days',
    level: 'all',
  },
  {
    id: '3',
    title: 'Family Surf Experience',
    description: 'Fun family-friendly surf experience',
    price: 300,
    duration: '2 hours',
    level: 'beginner',
  },
];

const mockTestimonials = [
  {
    id: '1',
    customer_name: 'John Smith',
    review: 'Best surfing experience ever! Highly recommend.',
    rating: 5,
    location: 'essaouira',
    customer_photo: null,
  },
  {
    id: '2',
    customer_name: 'Amine taghi',
    review: 'tbarklah 3likom , service top!',
    rating: 5,
    location: 'essaouira',
    customer_photo: null,
  },
  {
    id: '3',
    customer_name: 'leila raj',
    review: 'Amazing instructors and beautiful waves. Will come back again!',
    rating: 5,
    location: 'essaouira',
    customer_photo: null,
  },
];

export default function Home() {
  const [isLoading, setIsLoading] = useState(true);
  const { products, services } = useAppContext();

  useEffect(() => {
    // Simulate loading
    setTimeout(() => setIsLoading(false), 500);
  }, []);

  const handleBookLesson = (lesson) => {
    // open WhatsApp with a message including the lesson title when available
    const text = lesson && lesson.title ? `I would like to book: ${lesson.title}` : 'I would like to book a surf lesson';
    window.open(`https://wa.me/212615162643?text=${encodeURIComponent(text)}`, '_blank');
  };

  const handleExploreProducts = () => {
    const el = document.getElementById('products');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-cyan-50">
        <div className="text-center">
          <Loader2 className="w-12 h-12 animate-spin text-blue-500 mx-auto mb-4" />
          <p className="text-gray-600">Loading the waves...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <HeroSection onBookLesson={handleBookLesson} onExploreProducts={handleExploreProducts} />
      
      <div id="coaching">
        <CoachingSection lessons={services && services.length ? services : mockLessons} onBookNow={handleBookLesson} />
      </div>

      <div id="products">
        <ProductsGrid products={products} />
      </div>

      <div id="about">
        <AboutSection />
      </div>

      <div id="testimonials">
        <TestimonialsSection testimonials={mockTestimonials} />
      </div>

      <Footer />
    </div>
  );
}